
import PropTypes from 'prop-types'
import { useEffect, useMemo } from 'react'
import {
  useFetchOfficeLocations,
  useOfficeLocations
} from '../../redux/slices/office-locations'
import Select from './Select'

export default function OfficeLocationSelect({ practiceId, ...props }) {
  const fetchOfficeLocations = useFetchOfficeLocations()
  const officeLocations = useOfficeLocations(practiceId)

  useEffect(() => {
    if (practiceId) {
      fetchOfficeLocations(practiceId)
    }
  }, [practiceId, fetchOfficeLocations])

  const options = useMemo(() => {
    if (officeLocations?.length > 0) {
      return officeLocations.map(loc => ({ ...loc, id: String(loc.id) }))
    }
    return []
  }, [officeLocations])

  return (
    <Select
      options={options}
      showSearch
      allowClear
      optionFilterProp="children"
      placeholder="Select office location"
      {...props}
    />
  )
}

OfficeLocationSelect.propTypes = {
  practiceId: PropTypes.string.isRequired,
}
